import { deleteSociety } from 'modules/society/utils/deleteSociety';

export default [
  {
    icon: 'ni-eye',
    text: 'Ver Socios',
    url: '/socios',
  },
  {
    icon: 'ni-edit',
    text: 'Editar',
    url: '/perfil-sociedad/datos',
  },
  {
    icon: 'ni-trash',
    text: 'Eliminar',
    action: deleteSociety,
  },
];
